import {
  GET_PAGINATED_BATCHES,
  GETTING_PAGINATED_BATCHES,
  GETTING_PAGINATED_BATCHES_SUCCEEDED,
  GETTING_PAGINATED_BATCHES_FAILED,
  CLEAR_BATCH_STORE,
  UPDATE_BATCH_FILTERS,
  RESET_BATCH_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  gettingPaginated: true,
  paginatedList: [],
  filters: {
    searchInput: '',
    sortBy: 'createTime',
    sortOrder: 'DESC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTypes: []
  }
};

export default createReducer(initialState, {
  [GET_PAGINATED_BATCHES]: state => {
    state.error = {};
    return state;
  },
  [GETTING_PAGINATED_BATCHES]: state => {
    state.gettingPaginated = true;
  },
  [GETTING_PAGINATED_BATCHES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action?.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_PAGINATED_BATCHES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [CLEAR_BATCH_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },

  [UPDATE_BATCH_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },

  [RESET_BATCH_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = {
      ...initialState.filters
    };
    return state;
  }
});
